export default __webpack_public_path__ + "static/media/1.be789be9.mp3";